<div class="vehicles-container">
  <!-- Header Section -->
  <div class="vehicles-header">
    <h3 class="vehicles-title">Vehicles</h3>
    <button class="add-vehicle-btn" (click)="onAddVehicle()" *ngIf="vehicles.length < 5">
      <img src="assets/images/customer/plus.svg" alt="Add" class="btn-icon" />
      <span class="btn-text">Add Vehicle</span>
    </button>
  </div>

  <!-- Vehicle Limit Warning -->
  <div class="vehicle-limit-warning" *ngIf="vehicles.length >= 5">
    <div class="warning-content">
      <div class="warning-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="9.99935" cy="10.0003" r="8.33333" fill="#F57600" />
          <path
            d="M9.99203 12.5H9.99951"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 10L10 6.66667"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="warning-text">
        <div class="warning-title">Vehicle limit reached!</div>
        <div class="warning-message">
          You can only add up to 5 vehicles to a family plan. Remove an existing vehicle to add
          another.
        </div>
      </div>
    </div>
  </div>

  <!-- Add Vehicle Card -->
  <app-add-vehicle-card
    [isVisible]="showAddVehicleCard"
    [customerId]="customer?.id || ''"
    [customerSource]="customer?.source || null"
    [editMode]="editMode"
    [vehicleToEdit]="vehicleToEdit"
    (vehicleAdded)="onVehicleAdded($event)"
    (vehicleUpdated)="onVehicleUpdated($event)"
    (cardClosed)="onCardClosed()"
  >
  </app-add-vehicle-card>

  <!-- Loading State -->
  <div class="vehicles-content" *ngIf="loading">
    <div class="loading-state">
      <div class="loading-spinner"></div>
      <p>Loading vehicles...</p>
    </div>
  </div>

  <!-- Error State -->
  <div class="vehicles-content" *ngIf="error && !loading">
    <div class="error-state">
      <p class="error-message">{{ error }}</p>
      <button class="retry-btn" (click)="loadVehicles()">Try Again</button>
    </div>
  </div>

  <!-- Vehicle Cards -->
  <div class="vehicles-content" *ngIf="!loading && !error">
    <!-- add here also -->
    <app-vehicle-card
      *ngFor="let vehicle of vehicles; trackBy: trackByIndex"
      [vehicle]="vehicle"
      [disabled]="editMode && vehicleToEdit?.id === vehicle.id"
      (editVehicle)="onEditVehicle($event)"
      (deleteVehicle)="onDeleteVehicle($event)"
      (showDeleteModal)="onShowDeleteModal($event)"
      class="vehicle-card-item"
    >
    </app-vehicle-card>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="vehicles.length === 0 && !showAddVehicleCard">
      <p>No vehicles found for this customer.</p>
      <p class="empty-hint">Click "Add Vehicle" to add the first vehicle.</p>
    </div>
  </div>

  <!-- Delete Vehicle Alert Modal -->
  <app-delete-vehicle-alert-modal
    [isOpen]="showDeleteModal"
    (cancel)="onCloseDeleteModal()"
    (confirm)="onConfirmDelete(vehicleToDelete!)"
  >
  </app-delete-vehicle-alert-modal>

  <!-- CWS-1384: the vehicle still carries a membership. Not a failed request, so it
       gets a modal naming the cancel path rather than a toast that slides away. -->
  <app-alert-modal
    [isOpen]="!!membershipBlockMessage"
    title="Membership still active"
    [description]="membershipBlockMessage || ''"
    primaryButtonText="Got it"
    secondaryButtonText=""
    primaryButtonClass="btn-primary"
    (close)="onCloseMembershipBlock()"
    (primaryAction)="onCloseMembershipBlock()"
    (secondaryAction)="onCloseMembershipBlock()"
  >
  </app-alert-modal>
</div>
